interface GradeLexileLevel {
  formattedGrade: string;
  lexileRange: string;
  rawLexileRange: number[];
  value: string;
}

export type GradeBandKey = keyof typeof NUMERICAL_GRADE_BANDS;

export const GRADEANDLEXILELEVELS: { [index: number]: GradeLexileLevel } = {
  0: {
    formattedGrade: "Grade KG",
    lexileRange: "0 L",
    rawLexileRange: [0, 0],
    value: "GRADE_K",
  },

  1: {
    formattedGrade: "Grade 1",
    lexileRange: "1 - 299 L",
    rawLexileRange: [1, 299],
    value: "GRADE_1",
  },

  2: {
    formattedGrade: "Grade 2",
    lexileRange: "300 - 500 L",
    rawLexileRange: [300, 500],
    value: "GRADE_2",
  },

  3: {
    formattedGrade: "Grade 3",
    lexileRange: "501 - 620 L",
    rawLexileRange: [501, 620],
    value: "GRADE_3",
  },

  4: {
    formattedGrade: "Grade 4",
    lexileRange: "621 - 780 L",
    rawLexileRange: [621, 780],
    value: "GRADE_4",
  },

  5: {
    formattedGrade: "Grade 5",
    lexileRange: "781 - 920 L",
    rawLexileRange: [781, 920],
    value: "GRADE_5",
  },

  6: {
    formattedGrade: "Grade 6",
    lexileRange: "921 - 1010 L",
    rawLexileRange: [921, 1010],
    value: "GRADE_6",
  },

  7: {
    formattedGrade: "Grade 7",
    lexileRange: "1011 - 1109 L",
    rawLexileRange: [1011, 1109],
    value: "GRADE_7",
  },

  8: {
    formattedGrade: "Grade 8",
    lexileRange: "1110 - 1180 L",
    rawLexileRange: [1110, 1180],
    value: "GRADE_8",
  },

  9: {
    formattedGrade: "Grade 9",
    lexileRange: "1181 - 1260 L",
    rawLexileRange: [1181, 1260],
    value: "GRADE_9",
  },

  10: {
    formattedGrade: "Grade 10",
    lexileRange: "1181 - 1260 L",
    rawLexileRange: [1181, 1260],
    value: "GRADE_10",
  },

  11: {
    formattedGrade: "Grade 11",
    lexileRange: "Original Level",
    rawLexileRange: [],
    value: "GRADE_11",
  },

  12: {
    formattedGrade: "Grade 12",
    lexileRange: "Original Level",
    rawLexileRange: [],
    value: "GRADE_12",
  },

  13: {
    formattedGrade: "College",
    lexileRange: "Original Level",
    rawLexileRange: [],
    value: "GRADE_COLLEGE",
  },
};

export const NUMERICAL_GRADE_BANDS = {
  GRADE_K: 0,
  GRADE_1: 1,
  GRADE_2: 2,
  GRADE_3: 3,
  GRADE_4: 4,
  GRADE_5: 5,
  GRADE_6: 6,
  GRADE_7: 7,
  GRADE_8: 8,
  GRADE_9: 9,
  GRADE_10: 10,
  GRADE_11: 11,
  GRADE_12: 12,
  GRADE_LOWER_ELEMENTARY: 2,
  GRADE_LOWER_AND_UPPER_ELEMENTARY: 4,
  GRADE_UPPER_ELEMENTARY: 4,
  GRADE_MIDDLE_SCHOOL: 7,
  GRADE_HIGH_SCHOOL: 10,
  GRADE_COLLEGE: 13,
} as const;

export type GradeBand =
  (typeof NUMERICAL_GRADE_BANDS)[keyof typeof NUMERICAL_GRADE_BANDS];
export type GradeBandName = keyof typeof NUMERICAL_GRADE_BANDS;
